<template>
    <div class="expand">
        <label class="head" @click="isExpanded = !isExpanded">
            <h3>{{ title }}</h3>
        </label>
        <div class="body" v-if="isExpanded">
            <slot></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: "Expand",
        props: {
            expand: {
                type: Boolean,
                default: false
            },
            title: String
        },
        created() {
            this.isExpanded = this.$props.expand;
        },
        data() {
            return {
                isExpanded: false
            }
        }
    }
</script>